import { render, staticRenderFns } from "./TermsOfSaleAgreementCheckbox.vue?vue&type=template&id=38250986&scoped=true&"
import script from "./TermsOfSaleAgreementCheckbox.vue?vue&type=script&lang=js&"
export * from "./TermsOfSaleAgreementCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfSaleAgreementCheckbox.vue?vue&type=style&index=0&id=38250986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38250986",
  null
  
)

export default component.exports